import Utils from "@/utilities/Utils";
import { mapData } from "@/utilities/DataMapping";
import { IPagePart, PagePart } from "./PagePart";
import { IPathwayPage, PathwayPage } from "@/model/PathwayPage";

export interface IPage {
    previousID: string;
    nextID: string;
    id: string;
    briefingID: string;
    description: string;
    isQuiz: boolean;
    sectionID: string;
    displayOrder: number;
    copiedFromID: string;
    created: Date;
    createdByUserID: string;
    lastUpdated: Date;
    lastUpdatedByUserID: string;
    deleted: Date;
    deletedByUserID: string;

    parts: Array<IPagePart>;
}

export class Page implements IPage {

    constructor(data?: IPage) {
        if (data) this.update(data);
    }

    update(data: IPage): Page {
        mapData(data, {
            root: () => this,
            parts: (data: IPagePart) => new PagePart(data),
            pathways: (data: IPathwayPage) => new PathwayPage(data),
        });
        return this;
    }

    previousID: string = Utils.emptyGuidValue;
    nextID: string = Utils.emptyGuidValue;
    id: string = Utils.emptyGuidValue;
    briefingID: string = Utils.emptyGuidValue;
    description: string = "";
    isQuiz: boolean = false;
    sectionID: string = "";
    displayOrder: number = 0;
    copiedFromID: string = Utils.emptyGuidValue;
    created: Date = new Date(Utils.emptyDateValue);
    createdByUserID: string = Utils.emptyGuidValue;
    lastUpdated: Date = new Date(Utils.emptyDateValue);
    lastUpdatedByUserID: string = Utils.emptyGuidValue;
    deleted: Date = new Date(Utils.emptyDateValue);
    deletedByUserID: string = Utils.emptyGuidValue;

    parts: Array<PagePart> = [];
    pathways: Array<PathwayPage> = [];

    // client-side only fields
    sectionDisplayOrder: number = 0;
    hasSelectedPathway: boolean = false;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}
